import { projectsPagePath } from '@/pages/projects/ProjectsPage.shared';

export const projectBplusPagePath = projectsPagePath + '/b-plus/:productTypeSlug?';